import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { getHubAndTierFromApiName } from 'ui-addon-upgrades/ums/utils';
export const SUB_PAGE_TYPE = {
  SUITE_STARTER_PPP: 'suite-starter-ppp',
  HUB_STARTER_PPP: 'hub-starter-ppp',
  HUB_PROFESSIONAL_PPP: 'hub-professional-plus-ppp',
  HUB_ENTERPRISE_PPP: 'hub-enterprise-ppp',
  ADDON_PPP: 'addon-ppp'
};
export const _determineUpgradePageSubPage = upgradePointApiName => {
  if (upgradePointApiName === CRM_SUITE_STARTER_BUNDLE) {
    return SUB_PAGE_TYPE.SUITE_STARTER_PPP;
  }
  const {
    tier
  } = getHubAndTierFromApiName(upgradePointApiName);
  if (tier === STARTER.toLowerCase()) {
    return SUB_PAGE_TYPE.HUB_STARTER_PPP;
  }
  if (tier === PROFESSIONAL.toLowerCase()) {
    return SUB_PAGE_TYPE.HUB_PROFESSIONAL_PPP;
  }
  if (tier === ENTERPRISE.toLowerCase()) {
    return SUB_PAGE_TYPE.HUB_ENTERPRISE_PPP;
  }
  return SUB_PAGE_TYPE.ADDON_PPP;
};